import React from "react";

import { useAppQuery } from "../../../api/fetchClient";
import { hcp, hospitalicon, patient } from "../../../assets/Icons/icons";
import { GET_DASHBOARD } from "../../../api/url";
import { Card, EmptyState, Loader, PageHeader } from "../../../components/ui";
import { strings } from "../../../strings/strings";

const Dashboard = () => {
  const pageHeader = {
    title: strings.dashboard,
    description: strings.dashboarddescription,
  };

  const { data, isLoading, error } = useAppQuery({
    queryKey: ["dashboard"],
    url: `${GET_DASHBOARD}`,
    method: "GET",
    enabled: true,
  });

  const results = data?.results || {};

  const statItems = [
    { label: strings.totalhcps, value: results.totalHCP || 0, icon: hcp },
    {
      label: strings.totalpatients,
      value: results.totalPatients || 0,
      icon: patient,
    },
    {
      label: strings.totalHospital,
      value: results.hospitalCount || 0,
      icon: hospitalicon,
    },
  ];

  if (isLoading) {
    return (
      <div>
        <div className="max-w-7xl mx-auto">
          <PageHeader title={pageHeader.title} description={pageHeader.description} className="mb-6" />
          <Card>
            <Loader />
          </Card>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div>
        <div className="max-w-7xl mx-auto">
          <PageHeader title={pageHeader.title} description={pageHeader.description} className="mb-6" />
          <Card>
            <EmptyState
              message={strings.failtoloaddashboard}
              description={error?.message}
            />
          </Card>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="max-w-7xl mx-auto">
        <PageHeader title={pageHeader.title} description={pageHeader.description} className="mb-6" />
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-6">
          {statItems.map((item) => (
            <div
              key={item.label}
              className={`bg-white rounded-2xl p-5 flex items-center gap-5 shadow-md hover:shadow-xl hover:scale-[1.015] transition all duration-200 cursor-pointer`}
            >
              <div className="h-14 w-14 rounded-xl flex items-center justify-center shrink-0 bg-primary/20">
                <img src={item.icon} alt={item.label} className="h-8 w-8 object-contain" />
              </div>
              <div>
                <p className="text-base text-secondary font-semibold">{item.label}</p>
                <p className="text-3xl text-secondary font-bold">{item.value}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
